import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
import {
	DatacenterViewCustomizationComponent
} from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { ListFilterComponent } from '../shared/components/filter/list-filter.component';
import { canActivateForServiceParameter } from '../shared/guards/service.guard';

import { OrderListComponent } from './components/list/order-list.component';
import { BatchListComponent } from './components/list/batch-list.component';
import { OrderCardComponent } from './components/card/order-card.component';
import { orderTrackingGuard } from './components/guards/order-tracking.guard';
import { BatchCardComponent } from './components/card/batch-card.component';
import { OrderDeliveryComponent } from './components/order-delivery.component';
import { ScheduleBusinessOrderListComponent } from './components/list/schedule-business-order-list.component';
import { ScheduleBusinessOrderCardComponent } from './components/card/schedule-business-order-card.component';
import { ShipmentCardComponent } from './components/card/shipment-card.component';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ORDER_TRACKING }
	},
	{
		path: 'dashboard',
		component: OrderDeliveryComponent,
		canActivate: [orderTrackingGuard],
		data: { pageName: 'Order Tracking - Dashboard', service: SERVICE_ANALYTICS.ORDER_TRACKING }
	},
	{
		path: 'order',
		children: [
			{
				path: '',
				redirectTo: 'list',
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ORDER_TRACKING }
			},
			{
				path: 'list',
				children: [
					{
						path: '',
						component: OrderListComponent,
						data: { pageName: 'Orders - List', service: SERVICE_ANALYTICS.ORDER_SPOT, type: 'order' }
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: { pageName: 'Orders - Filter', service: SERVICE_ANALYTICS.ORDER_SPOT }
					}
				]
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Orders - Datacenter',
							service: SERVICE_ANALYTICS.ORDER_SPOT,
							type: 'order',
							title: 'datacenter.orders',
							exportExcelName: 'Orders'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Orders - Datacenter Customization', service: SERVICE_ANALYTICS.ORDER_SPOT }
					}
				]
			},
			{
				path: 'card/:supplierReference/:supplierItem',
				component: OrderCardComponent,
				data: { pageName: 'Orders - Card', service: SERVICE_ANALYTICS.ORDER_SPOT }
			}
		]
	},
	{
		path: 'batch',
		children: [
			{
				path: '',
				redirectTo: 'list',
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.BATCH }
			},
			{
				path: 'list',
				children: [
					{
						path: '',
						component: BatchListComponent,
						data: { pageName: 'Batches - List', service: SERVICE_ANALYTICS.BATCH, type: 'batch' }
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: { pageName: 'Batches - Filter', service: SERVICE_ANALYTICS.BATCH }
					}
				]
			},
			{
				path: 'card/:id',
				component: BatchCardComponent,
				data: { pageName: 'Batches - Card', service: SERVICE_ANALYTICS.BATCH }
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Batches - Datacenter',
							service: SERVICE_ANALYTICS.BATCH,
							type: 'batch',
							title: 'datacenter.batches',
							exportExcelName: 'Batches',
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Batches - Datacenter Customization', service: SERVICE_ANALYTICS.BATCH }
					}
				]
			}
		]
	},
	{
		path: 'shipment',
		children: [
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Shipments - Datacenter',
							service: SERVICE_ANALYTICS.SHIPMENT,
							type: 'shipment',
							title: 'datacenter.data-center-shipments',
							exportExcelName: 'Shipments',
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Shipments - Datacenter Customization', service: SERVICE_ANALYTICS.SHIPMENT }
					}
				]
			},
			{
				path: 'card/:id',
				component: ShipmentCardComponent,
				data: { pageName: 'Shipments - Card', service: SERVICE_ANALYTICS.SHIPMENT }
			}
		]
	},
	{
		path: 'schedule-business-order',
		children: [
			{
				path: '',
				redirectTo: 'list',
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ORDER_SCHEDULE }
			},
			{
				path: 'list',
				children: [
					{
						path: '',
						component: ScheduleBusinessOrderListComponent,
						data: {
							pageName: 'Schedule Business Orders - List',
							service: SERVICE_ANALYTICS.ORDER_SCHEDULE,
							type: 'schedule-business-order'
						}
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: {
							pageName: 'Schedule Business Orders - Filter',
							service: SERVICE_ANALYTICS.ORDER_SCHEDULE
						}
					}
				]
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						canActivate: [canActivateForServiceParameter('PORDT', 'SBOrder', 'True')],
						component: DatacenterComponent,
						data: {
							pageName: 'Schedule Business Orders - Datacenter',
							service: SERVICE_ANALYTICS.ORDER_SCHEDULE,
							type: 'schedule-business-order',
							title: 'datacenter.schedule-business-orders',
							exportExcelName: 'Schedule business orders'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: {
							pageName: 'Schedule Business Orders - Datacenter Customization',
							service: SERVICE_ANALYTICS.ORDER_SCHEDULE
						}
					}
				]
			},
			{
				path: 'card/:supplierOrderNumber',
				canActivate: [canActivateForServiceParameter('PORDT', 'SBOrder', 'True')],
				component: ScheduleBusinessOrderCardComponent,
				data: {
					pageName: 'Schedule Business Orders - Card',
					service: SERVICE_ANALYTICS.ORDER_SCHEDULE
				}
			}
		]
	}
];
